import { gql } from "@apollo/client";
import { SubTaskInfoFragment, TasksListFragment } from "./fragments";

export const SUBTASK_BY_STATUS_AND_CLIENT_ID = gql`
  query allSubTasksByClient($params: SubTasksByClientFetchParams!, $queries: SubTasksFetchQueries) {
    allSubTasksByClient(params: $params, queries: $queries) {
      data {
        ...SubTaskInfo
      }
      countTotal
      totalPages
      currentPage
    }
  }

  ${SubTaskInfoFragment}
`;
export const ALL_TASKS = gql`
  query allTasks($queries: TasksFetchQueries) {
    results: allTasks(queries: $queries) {
      code
      error
      message
      countTotal
      data {
        ...TasksListFragment
      }
    }
  }
  ${TasksListFragment}
`;
